import Map from "ol/Map";
import { distance_latLong_toKM, distance_latLong_toMi, getCookie, initializeTooltips, mi_to_meter, titleCase_withStates } from "../util/general_util";
import { initMap_OPENLAYERS } from "./map/map_initialization";
import { clearLayer, enlargeIcon, highlightStayPin, setLayerVisible, shrinkIcon, unhighlightStayPin } from "./map/helper_functions";
import { init_map_listeners } from "./map/map_listeners";
import { check_addStay_access } from "./freemiumUtil";
import { Campground_Data, Trip_Cluster_v2, Trip_leg_v2, Trip_v2 } from "../util/tripPlanner_types";
import { added_genieWish, addedStayTemplate, addedStayTemplate_customStay, stayTemplate, stayTemplate_addStay, stayTemplate_addStay_noAccess, stayTemplate_genieMatch, stayTemplate_genieScore, stayTemplate_s2nSection, stayTemplate_sponsored } from "./templates";
import mustache, { render } from 'mustache';
import { display_potential_stay_pins, zoomToStop } from "./map/map_displays";
import { get_genieMatches, get_stop_from_stopID } from "./util/helper_functions";
import { init_rvRental_display } from "../tripPlanner/tripPlanner_rvShareIntegration_scripts";
import { get_favoritedCamps, get_stop_img } from "./api_utils";
import { filter_potential_stays } from "./trip_utils";
import { sponsoredStaySuggestion_impression_log } from "../log";

export function display_wishes_stopPopout(stop:Trip_Cluster_v2) {
	$("#stopWishesDisplay").html("");
	if (stop.wishes) {
		stop.wishes.forEach(function(val, idx) {
			$("#stopWishesDisplay").append(mustache.render(
				added_genieWish,
				{
					wishes_list:val,
					// legIndex: legIndex,
					// stopIndex: stopIndex,
					stopID: stop.stopID,
					idx:idx
				}
			));
		});
		$("#stopWishesDisplay_wrapper").show();
	} else {
		$("#stopWishesDisplay_wrapper").hide();
	};

	document.getElementById("stopPopout").dispatchEvent(new CustomEvent("wishes.displayed"));
};

export function display_stop_popout(stopID:string, suggestedStop:boolean, showDefaultTab:boolean) {
	const stopData = get_stop_from_stopID(stopID, window.tripPlannerCurrentTrip);
	if (stopData == null) return;
	const stop = stopData.stop;

	if (!$("#poi-count-disp").hasClass("d-none")) $("#poi-count-disp").addClass("d-none");
	if (!$("#no-pois-disp").hasClass("d-none")) $("#no-pois-disp").addClass("d-none");

	$("#singleStopWishesOutput").html("");
	$("#stop-wishes-results").hide();
	$("#stop-wishes-input").show();
	const stopWishesForm = $("#stopWishesForm");
	const stopWishesBtn = stopWishesForm.find("button[type='submit']");
	if (stopWishesForm.find("input[use-interests]").is(":checked")) {
		stopWishesBtn.removeClass("disabled");
	} else {
		stopWishesForm.find("[whattodo]").val("");
		if (!stopWishesBtn.hasClass("disabled")) stopWishesBtn.addClass("disabled");
	};


	if (!$("#stopPopoutMap").hasClass("d-none")) {
		$("#stopPopoutMap").addClass("d-none");
		$("#stopPopout_mapHide").addClass("d-none");
		$("#stopPopout_mapShow").removeClass("d-none");
	};
	$("#stayList").removeClass("d-none");

	// (document.getElementById("stopPopoutImg") as HTMLImageElement).src = `/static/images/browseCamps/${stop.altStops[0].camp.administrative_area_level_1_long.toLowerCase()}/1.webp`;

	get_stop_img(stop.clusterTitle).then(img_url => {
		(document.getElementById("stopPopoutImg") as HTMLImageElement).src = img_url;
	}).catch(e => {

	});

	$('a[href="#staysTab_stays"]').tab("show");
	/*********** RVSHARE STUFF */
	clearLayer(window.rvShareMarkerLayer);
	document.getElementById("searchRVrentals").setAttribute("loc",JSON.stringify(stop.coords));
	$("#RVrentalsDisp").html();
	$("#rvFiltersContainer").removeClass("d-flex");
	if (!$("#rvFiltersContainer").hasClass("d-none")) $("#rvFiltersContainer").addClass("d-none");

	init_rvRental_display(stop);
	/************* */

	const popout:JQuery<HTMLElement> = $("#stopPopout");
	$(".tripOverviewStop").removeClass("active");
	$(this).closest(".tripOverviewStop").addClass("active");

	$("[poi-filter]").prop("checked",false);
	$('a[data-bs-toggle="tab"][href="#pois-hidden"]').tab("show");
	$("#poiCategoryTabs").removeClass("d-none");
	$("[poi_disp]").html("");
	$("[poi_disp_bg]").css("background-size","auto");
	$("[poi-noFiltersDisp]").removeClass("d-none");

	if (showDefaultTab) {
		popout.find('[data-bs-toggle="tab"][href="#stays"]').tab("show");
	};

	popout.find("[stopTitle]").html(
		titleCase_withStates(stop.clusterTitle)
	);
	popout.attr("stopID",stopID);

	// zoomToStop(window.mainTripPlannerMap, stop, stop.fromUserQuery);

	$("#editNotes").attr("stopID",stopID);
	if (stop.notes != undefined) {
		$("#editNotes").html(stop.notes);
	} else {
		$("#editNotes").html("");
	};

	$("#stopWishesForm").attr("stopID",stopID);

	// display_wishes_stopPopout(stop);

	create_stayRadius_histogram(stop, "radiusHistogram");

	popout.attr("stopID",stopID);

	stopPopout_display_added_stays(stop, window.tripPlannerCurrentTrip.filters.dist_unit);
	if (!stop.gotMatchScores) {
		get_genieMatches(stop).then(() => {
			if (popout.find(".tab-pane#stays").hasClass("active")) {
				display_potential_stay_pins(stop);
			};
			display_potential_stays(window.tripPlannerCurrentTrip, stop, suggestedStop);

			popout.removeClass("d-none");
			if (!popout.hasClass("d-flex")) popout.addClass("d-flex");
			popout.trigger("element.shown");
		}).catch(e => {
			console.error(e);
		});
	} else {
		if (popout.find(".tab-pane#stays").hasClass("active")) {
			display_potential_stay_pins(stop);
		};
		display_potential_stays(window.tripPlannerCurrentTrip, stop, suggestedStop);

		popout.removeClass("d-none");
		if (!popout.hasClass("d-flex")) popout.addClass("d-flex");
		popout.trigger("element.shown");
	};

	$(".tripOverviewStop").removeClass("active");
    $(`.tripOverviewStop[stopID="${stopID}"]`).addClass("active");

	popout.attr("suggestedStop", suggestedStop.toString());
	if (suggestedStop) {
		popout.find("[suggestedStopToast]").removeClass("d-none");
		popout.find("[suggestedStopToast]").find("[lock-stop]").attr("stopID",stop.stopID);

		// popout.find('[data-bs-toggle="tab"][href="#wishes"]').addClass("disabled");
		popout.find('[data-bs-toggle="tab"][href="#notes"]').addClass("disabled");
		// popout.find('[data-bs-toggle="tab"][href="#wishes"]').addClass("d-none");
		// popout.find('[data-bs-toggle="tab"][href="#notes"]').addClass("d-none");

		popout.find('[data-bs-toggle="tab"][href="#notes"]').parent().attr("data-bs-toggle","tooltip");
		popout.find('[data-bs-toggle="tab"][href="#notes"]').parent().attr("title", "Lock this stop to add notes");

		initializeTooltips();
	} else {
		popout.find("[suggestedStopToast]").addClass("d-none");
		// popout.find('[data-bs-toggle="tab"][href="#wishes"]').removeClass("d-none");
		// popout.find('[data-bs-toggle="tab"][href="#notes"]').removeClass("d-none");
		popout.find('[data-bs-toggle="tab"][href="#wishes"]').removeClass("disabled");
		popout.find('[data-bs-toggle="tab"][href="#notes"]').removeClass("disabled");

		popout.find('[data-bs-toggle="tab"][href="#notes"]').parent().removeAttr("data-bs-toggle");
		popout.find('[data-bs-toggle="tab"][href="#notes"]').parent().removeAttr("title");
	};
	if (!popout.find("[stopAddedToast]").hasClass("d-none")) {
		popout.find("[stopAddedToast]").addClass("d-none");
	};

	$("#stopPopoutCollapse").collapse("show");

	if (!showDefaultTab && $('[data-bs-toggle="tab"][href="#pois"]').hasClass("active")) {
		$('[data-bs-toggle="tab"][href="#pois"]').trigger("shown.bs.tab");
	};

	popout.removeClass("d-none");
	if (!popout.hasClass("d-flex")) popout.addClass("d-flex");
	popout.trigger("element.shown");

};

export function show_map_loadingIcon_genieJourneySearch() {
	let map: Map = window.mainTripPlannerMap;
	let loadingIconPopup = window.map_loadingIcon_genieJourney;

	let center = map.getView().getCenter();
	loadingIconPopup.setPosition(center);
	$("#mapLoadingIcon-genieJourneySearch").removeClass('d-none')
};
export function hide_map_loadingIcon_genieJourneySearch() {
	$("#mapLoadingIcon-genieJourneySearch").addClass('d-none')
}


export function show_map_loadingIcon(loadingText:string|undefined) {
	if (loadingText == undefined) {
		loadingText = "Creating your trip!";
	};
	$("#mapLoadingText").text(loadingText);

	$("#mapLoadingIcon").removeClass("d-none");
};
export function hide_map_loadingIcon() {
	$("#mapLoadingIcon").addClass("d-none");
};

export function addSearchErrorFeedback_tripPlanner(inputEl:JQuery<HTMLElement>, errMsg:string,isGenieJourney:boolean) {
	inputEl.css("--bs-bg-opacity","0.75");
	inputEl.css("border-radius","6.522px");

	if (true) {
		inputEl.parent().css("border","1px solid #B32C2C");
		inputEl.parent().css("border-radius","6.522px");
		inputEl.parent().find("span.input-group-text").css("border-radius","6.522px");
	} else {
		inputEl.parent().find("textarea").css("border","1px solid #B32C2C");
		inputEl.parent().find("textarea").css("border-radius","6.522px");
		inputEl.parent().find("textarea").find("span.input-group-text").css("border-radius","6.522px");
	}

	let existantErrFeedback = inputEl.parent().find("[search_err_feedback]");
	if (existantErrFeedback.length) existantErrFeedback.remove();

	$(`
		<div search_err_feedback="" class="d-flex flex-row justify-content-center align-items-center fs-sm bottom-0 end-0 w-100 gap-1" style="background-color:#B32C2C;border-radius: 0px 0px 6.52px 6.52px;z-index:5;pointer-events:none;margin:0;">
			<i class="ai-alert-circle" style="color:white"></i>
			<span class="text-wrap text-white">${errMsg}</span>
		</div>
	`).insertAfter(inputEl);
};

export async function initMap_tripPlanner() {
	const map:Map = await initMap_OPENLAYERS();
	init_map_listeners(map);
	const mapLayer:string = getCookie("map");
	if (mapLayer.length) setLayerVisible(mapLayer);
};

function get_stay_render_data(campData:Campground_Data, stopID:string, includeFilterables:boolean, dist_unit:string) {
	// if (legIndex >= window.tripPlannerCurrentTrip.legs.length) return "";
	// const leg:Trip_leg_v2 = window.tripPlannerCurrentTrip.legs[legIndex];
	// if (stopIndex >= leg.clusters.length) return "";
	// const stop = leg.clusters[stopIndex];
	const stopData = get_stop_from_stopID(stopID, window.tripPlannerCurrentTrip);
	if (stopData == null) return;
	const stop = stopData.stop;
	if (campData.dist == undefined) {
		if (dist_unit == "km") {
			campData.dist = distance_latLong_toKM(
				{latitude:campData.camp.latitude, longitude:campData.camp.longitude},
				stop.coords
			);
		} else {
			campData.dist = distance_latLong_toMi(
				{latitude:campData.camp.latitude, longitude:campData.camp.longitude},
				stop.coords
			);
		};
	} else if (dist_unit == "km") {
		campData.dist = mi_to_meter(campData.dist)/1000;
	};

	const is_s2n:boolean = campData.camp.s2n_id != undefined && campData.camp.s2n_id != null

	const render_data:any = {
		camp: campData.camp,
		stockImgNum:((campData.camp.campID % 18) + 1),
		// legIndex: legIndex,
		// stopIndex: stopIndex,
		stopID: stop.stopID,
		dist: campData.dist,
		s2n: is_s2n,
		s2n_section: is_s2n? mustache.render(stayTemplate_s2nSection, {}): ""
	};
	if (campData.dist) {
		render_data.distSection = `Distance to stop: ${Math.round(campData.dist)}`;
		render_data.distSection += (dist_unit == "km")? "km": "mi";
	} else {
		render_data.distSection = "";
	}

	if (includeFilterables) {
		render_data.amenities = campData.amenities;
		render_data.activities = campData.activities;
		render_data.genie_score = campData.camp.genie_score;
		render_data.genieMatch = campData.camp.genieMatch;
		render_data.p_low = campData.camp.price_low;
		render_data.p_high = campData.camp.price_high;
		render_data.rv_len = campData.camp.max_RV_length;
	};

	if (campData.camp.genie_score) {
		render_data.genieScoreSection = mustache.render(stayTemplate_genieScore, {genie_score:campData.camp.genie_score});
	} else {
		render_data.genieScoreSection = ""
	};
	if (campData.camp.genieMatch) {
		render_data.genieMatchSection = mustache.render(stayTemplate_genieMatch, {genieMatch:campData.camp.genieMatch});
	} else {
		render_data.genieMatchSection = "";
	};

	return render_data;
};

export function init_stay_hover_listener() {

	$("[addedstay]").off("mouseenter");
	$("[addedstay]").on("mouseenter", function() {
		const staymarkers = window.stayMarkerLayer.getSource().getFeatures();
		const campID = parseInt($(this).attr("id"))
		for (let i=0;i<staymarkers.length;i++) {
			if (staymarkers[i].getProperties().campID == campID) {
				highlightStayPin(staymarkers[i]);
				break;
			};
		};
	});
	$("[addedstay]").off("mouseleave");
	$("[addedstay]").on("mouseleave", function() {
		const staymarkers = window.stayMarkerLayer.getSource().getFeatures();
		const campID = parseInt($(this).attr("id"))
		for (let i=0;i<staymarkers.length;i++) {
			if (staymarkers[i].getProperties().campID == campID) {
				unhighlightStayPin(staymarkers[i]);
				break;
			};
		};
	});
};


export function stopPopout_display_added_stays(stop:Trip_Cluster_v2, dist_unit:string) {
	$("#addedStaysList").html("");
	if (stop.selectedCamps.length) {
		for (let i:number = 0; i < stop.selectedCamps.length; i++) {
			const render_data = get_stay_render_data(stop.selectedCamps[i], stop.stopID, false, dist_unit);

			if (stop.selectedCamps[i].is_fake_camp) {
				$("#addedStaysList").append(mustache.render(
					addedStayTemplate_customStay,
					render_data
				));
			} else {
				$("#addedStaysList").append(mustache.render(
					addedStayTemplate,
					render_data
				));
			};
		};
		$("#stopPopout_addedStays").show();
	} else {
		$("#stopPopout_addedStays").hide();
	};

	$("#stopPopout_addedStays").find("[remove-stay]").on("click", function() {
		//already have a listener set up to handle this on the other stay card, so just trigger click on that
		const campID:number = parseInt(this.getAttribute("campID"));
		const stopID:string = this.getAttribute("stopID");
		$(`#stays-${stopID}`).find(`[remove-stay][campID="${campID}"]`).trigger("click");
	});

	init_stay_hover_listener();
};

export async function sort_stays(sortBy:string, staysWrapper:JQuery<HTMLElement>) {
	const stayElements:Array<HTMLElement> = staysWrapper.find("[unAddedStay]").toArray();
	switch(sortBy) {
		case "match":
			if (!window.favoritedCamps) {
				window.favoritedCamps = await get_favoritedCamps(null).catch(e => {console.error(e)});
			};
			const maxMatch = Math.max(...stayElements.map(function(el,idx) {
				const match:number = parseInt($(el).find("[camp_attributes]").attr("genieMatch"));
				if (Number.isNaN(match)) return 0;
				return match;
			}));
			stayElements.sort((a,b) => {
				const campID_A = parseInt($(a).attr("id"));
				const campID_B = parseInt($(b).attr("id"));
				let scoreA:number, scoreB:number;
				let matchA:number = parseInt($(a).find("[camp_attributes]").attr("genieMatch"));
				let matchB:number = parseInt($(b).find("[camp_attributes]").attr("genieMatch"));
				if (Number.isNaN(matchA)) matchA = 0;
				if (Number.isNaN(matchB)) matchB = 0;
				let genieScoreA:number = parseInt($(a).find("[camp_attributes]").attr("genie_score"));
				let genieScoreB:number = parseInt($(b).find("[camp_attributes]").attr("genie_score"));
				if (Number.isNaN(genieScoreA)) genieScoreA = 0;
				if (Number.isNaN(genieScoreB)) genieScoreB = 0;

				let A_favorited:boolean = false, B_favorited:boolean = false;
				if (window.favoritedCamps) {
					if (window.favoritedCamps.includes(campID_A)) A_favorited = true;
					if (window.favoritedCamps.includes(campID_B)) B_favorited = true;
				};

				if (A_favorited && B_favorited) return 0;
				else if (A_favorited && !B_favorited) return -1
				else if (B_favorited && !A_favorited) return 1;

				if (matchA == 0 && matchB == 0) {
					scoreA = genieScoreA;
					scoreB = genieScoreB;
				} else if (genieScoreA == 0 && genieScoreB == 0) {
					scoreA = matchA;
					scoreB = matchB;
				} else {
					scoreA = genieScoreA * (matchA / maxMatch);
					scoreB = genieScoreB * (matchB / maxMatch);
				};

				return scoreB - scoreA
			});
			break;
		case "dist":
			stayElements.sort((a,b) => {
				let scoreA:number = parseInt($(a).find("[camp_attributes]").attr("dist"));
				let scoreB:number = parseInt($(b).find("[camp_attributes]").attr("dist"));
				if (Number.isNaN(scoreA)) scoreA = Infinity;
				if (Number.isNaN(scoreB)) scoreB = Infinity;
				return scoreA - scoreB;
			});
			break;
		case "dist-reverse":
			stayElements.sort((a,b) => {
				let scoreA:number = parseInt($(a).find("[camp_attributes]").attr("dist"));
				let scoreB:number = parseInt($(b).find("[camp_attributes]").attr("dist"));
				if (Number.isNaN(scoreA)) scoreA = 0;
				if (Number.isNaN(scoreB)) scoreB = 0;
				return scoreB - scoreA;
			});
			break;
		case "price":
			stayElements.sort((a,b) => {
				let scoreA:number = parseInt($(a).find("[camp_attributes]").attr("p_low"));
				let scoreB:number = parseInt($(b).find("[camp_attributes]").attr("p_low"));
				if (Number.isNaN(scoreA)) scoreA = Infinity;
				if (Number.isNaN(scoreB)) scoreB = Infinity;
				return scoreA - scoreB;
			});
			break;
		case "price-reverse":
			stayElements.sort((a,b) => {
				let scoreA:number = parseInt($(a).find("[camp_attributes]").attr("p_high"));
				let scoreB:number = parseInt($(b).find("[camp_attributes]").attr("p_high"));
				if (Number.isNaN(scoreA)) scoreA = 0;
				if (Number.isNaN(scoreB)) scoreB = 0;
				return scoreB - scoreA;
			});
			break;
		case "genie-match":
			stayElements.sort((a,b) => {
				let matchA:number = parseInt($(a).find("[camp_attributes]").attr("genieMatch"));
				let matchB:number = parseInt($(b).find("[camp_attributes]").attr("genieMatch"));
				if (Number.isNaN(matchA)) matchA = 0;
				if (Number.isNaN(matchB)) matchB = 0;

				return matchB - matchA;
			});
			break;
		case "genie-score":
			stayElements.sort((a,b) => {
				let genieScoreA:number = parseInt($(a).find("[camp_attributes]").attr("genie_score"));
				let genieScoreB:number = parseInt($(b).find("[camp_attributes]").attr("genie_score"));
				if (Number.isNaN(genieScoreA)) genieScoreA = 0;
				if (Number.isNaN(genieScoreB)) genieScoreB = 0;
				return genieScoreB - genieScoreA;
			});
			break;
		default:
			break;
	};

	staysWrapper.html("");
	stayElements.forEach(function(element,idx) {
		staysWrapper.append(element);
	});

	document.getElementById("stopPopout").dispatchEvent(new CustomEvent("stays.displayed"))
};

export async function display_potential_stays(trip:Trip_v2, stop:Trip_Cluster_v2, suggestedStop:boolean) {
    if (stop.altStops == undefined || stop.altStops == null) return;

	$("#sponsoredCampsList").html("");
	$("#stayList").html("");
	$("#stayList").scrollTop(0);

	$("#staySearch").val("");

	$("#staysSortBy").val("match");

	$("#stopPopout_n_camps").html(`Showing ${stop.altStops.length} results`);

	const addStayAccess:{access:boolean, accessLvl:number, popupAttr:string} = check_addStay_access(trip);

	let impressions_data:Record<string,Array<number>> = {};

	if (!window.favoritedCamps) {
		window.favoritedCamps = await get_favoritedCamps(null).catch(e => {console.error(e)});
	};

	for (let i:number = 0; i < stop.altStops.length; i++) {
		const campData:Campground_Data = stop.altStops[i];

		const render_data = get_stay_render_data(campData, stop.stopID, true, trip.filters.dist_unit);


		if (addStayAccess.access) {
			render_data.addStaySection = mustache.render(
				stayTemplate_addStay, {
					stopID: stop.stopID,
					campID:campData.camp.campID
				}
			)
		} else {
			render_data.addStaySection = mustache.render(
				stayTemplate_addStay_noAccess, {
					addStayMinAccessLevel: addStayAccess.accessLvl,
					popupAttr: addStayAccess.popupAttr
				}
			);
		};

		render_data.favoritedSection = "";
		if (window.favoritedCamps) {
			if (window.favoritedCamps.includes(campData.camp.campID)) {
				render_data.favoritedSection = `<i role="button" data-bs-toggle="tooltip" data-bs-placement="top" title="Unsave" id="${campData.camp.campID}" class="unfavorite-trigger position-absolute top-0 end-0 me-1 mt-1 ai-favoritedHeart-filled text-white"></i>`;
			} else {
				render_data.favoritedSection = `<i role="button" data-bs-toggle="tooltip" data-bs-placement="top" title="Save" id="${campData.camp.campID}" class="favorite-trigger position-absolute top-0 end-0 me-1 mt-1 ai-favoritedHeart text-white"></i>`;
			};
		} else {
			render_data.favoritedSection = `<i role="button" data-bs-toggle="tooltip" data-bs-placement="top" title="Save" id="${campData.camp.campID}" class="favorite-trigger position-absolute top-0 end-0 me-1 mt-1 ai-favoritedHeart text-white"></i>`;
		};

		// if (suggestedStop) render_data.addStaySection = [
		// 	'<div add-camp-disabled="" suggested-stop-feedback="" class="square-md" style="color:grey;border-color:grey;"  role="button" data-bs-toggle="tooltip" title="Lock stop to add campgrounds">',
		// 	'<i class="ai-plus"></i>',
		// 	'</div>'
		// ].join("\n");


		if (campData.sponsoredEventId) {
			$("#sponsoredCampsList").append($(mustache.render(stayTemplate_sponsored, render_data)))

			let eventId:string = campData.sponsoredEventId;

			if (eventId in impressions_data) {
				impressions_data[eventId].push(campData.camp.campID);
			} else {
				impressions_data[eventId] = [campData.camp.campID];
			};

		} else {
			$("#stayList").append($(mustache.render(stayTemplate, render_data)));
		};
	};
	Object.keys(impressions_data).forEach(function(key) {
		sponsoredStaySuggestion_impression_log(
			key,
			impressions_data[key],
			stop.clusterTitle,
			stop.coords
		);
	});

	sort_stays("match", $("#stayList"));
	initializeTooltips();

	filter_potential_stays($("#stopPopout").find("#stayList"));
};

const getHistogram = (lat:number,lng:number):Promise<number[][]> => {
	return new Promise<number[][]>((resolve,reject) => {
		$.ajax({
			type: "get",
			url: `/campHistogram?lat=${lat}&lng=${lng}`,
			success: (data)  => {resolve(data);},
			error: (xhr,errStr,exc) => {reject(new Error(errStr));}
		})
	});
};

export function update_stayRadius_histogram(targetId:string) {
	if (!window.stayRadiusHistogram) return;
	const data = window.stayRadiusHistogram;

	const radius = parseInt($('#stopRadius').val().toString());

	const canvas:HTMLCanvasElement = document.getElementById(targetId) as HTMLCanvasElement;
	const ctx = canvas.getContext('2d');
	const width = canvas.width;
	const height = canvas.height;

	ctx.clearRect(0, 0, canvas.width, canvas.height);

	const barWidth = width / data.length;

	let curRad = 5
	for (let i = 0; i < data.length; i++) {

		const barHeight = data[i][1] * 5; // Scale bar height

		if (curRad <= radius) {
			ctx.fillStyle = "rgba(244,130,49,0.6)";
		} else {
			ctx.fillStyle = '#d9d9d9';
		};
		ctx.fillRect(i * barWidth, height - barHeight, barWidth - 2, barHeight);

		curRad += 5
	};
};

export async function create_stayRadius_histogram(stop:Trip_Cluster_v2, targetId:string) {
	const radius = parseInt($('#stopRadius').val().toString());

	try {
		const data:number[][] = await getHistogram(stop.coords.latitude, stop.coords.longitude);

		window.stayRadiusHistogram = data;

		update_stayRadius_histogram(targetId);
	} catch {
		return;
	};
};